// extracted by mini-css-extract-plugin
module.exports = {"root":"Category_root__zbBvZ","label":"Category_label__1gREq","content":"Category_content__3D4S9","header":"Category_header__3-ds_","location":"Category_location__1HCF3"};